import React, { useEffect, useState } from "react";
import {
  getTipoDeDocumento,
  postActualizarIDCirugia,
  postHorarioQuirofanos,
  postInsertIDCirugia,
  postInsertQuirofanos,
  postObtenerElUltimoIDCirugia,  
  postVerificarQuirofanoOcupado,
} from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import ModalHorariosQuirofanos from "./ModalHorariosQuirofanos";
import ModalListaDeSeleccionEmpresasXUsuario from "./ModalListaDeSeleccionEmpresasXUsuario";
import ModalListaDeSeleccionPacientesXNombreN from "./ModalListaDeSeleccionPacientesXNombreN";
import ModalListaSeleccionTurnosQuirofano from "./ModalListaSeleccionTurnosQuirofano";
import ModalProgramacioDeunaCirugiaQuirofanoN from "./ModalProgramacioDeunaCirugiaQuirofanoN";
import ModalQuirofanoOcupado from "./ModalQuirofanoOcupado";

const ModalProgramacionDeUnaCirugiaN = ({
  setmodalOnProgramacionDeCirugia,
  passDataActualizaTablaPacientes,
}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnQuirifanoN, setmodalOnQuirifanoN] = useState(false);
  const [modalOnSeleccionPaciente, setmodalOnSeleccionPaciente] =
    useState(false);
  const [modalOnEmpresasXUsuario, setmodalOnEmpresasXUsuario] = useState(false);
  const [modalOnTurnosQuirofano, setmodalOnTurnosQuirofano] = useState(false);
  const [modalOnQuirofanosOcupados, setmodalOnQuirofanosOcupados]=useState(false)
  const [modalOnHorarioQuirofanos, setmodalOnHorarioQuirofanos]=useState(false)
  const [dataHorariosQuirofanos, setdataHorariosQuirofanos]=useState([])
  const [diaQuirofano, setdiaQuirofano]=useState('')
  const [errorDataQuirofanosOcupados, seterrorDataQuirofanosOcupados]=useState([])
  const [errorSala, setErrorSala] = useState("");
  const [errorContrato, setErrorContrato] = useState("");
  const [errorHoraInicial, setErrorHoraInicial] = useState("");
  const [errorHoraFinal, setErrorHoraFinal] = useState("");
  const [errorFechaInicial, seterrorFechaInicial] = useState("");
  const [errorFechaFinal, setErrorFechaFinal] = useState("");
  const [errorNumeroDocumento, seterrorNumeroDocumento] = useState("");
  const [errorTipodeDocumento, seterrorTipodeDocumento] = useState("");
  const [horaInicial, setHoraInicial] = useState("");
  const [horaFinal, setHoraFinal] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFinal, setFechaFinal] = useState("");
  const [fechaActual, setFechaActual] = useState("");
  const [tipoDocumento, settipoDocumento] = useState([]);
  const [loading, setloading]=useState(true)
  //const [passActuaTablaPAcientes, setpassActuaTablaPAcientes]=useState({})
  const [passDataQuirofanoN, setpassDataQuirofanoN] = useState({
    codigoQuirofano: "",
    descripcionQuirofano: "",
    sedeQuirofano: "",
  });
  const [passDataUser, setpassDataUser] = useState({
    nombreUser: "",
    numeroUser: "",
    tipoDocumentoUser: "",
    sexoUser: "",
  });
  const [passDataContrato, setpassDataContrato] = useState({
    nomUser: "",
    descripcionNit: "",
  });

  

  // const pasarDataAtualizarTablaPacientes=(data)=>{
  //   setpassActuaTablaPAcientes(data)
  // }
  //const ref = useRef(null);
  const passDataContratoUser = (data) => {
    //ref.current.value = "";
    setpassDataContrato(data);
    //console.log(data,'contratoss')
    setErrorContrato("");
  };

  const passDataInfoUser = (data) => {
    setpassDataUser(data);
    seterrorNumeroDocumento("");
    seterrorTipodeDocumento("");
    //console.log(data,'datauserrrrrrrrr')
  };

  const passInfoDataQuirofano = (data) => {
    //console.log(data)
    setpassDataQuirofanoN(data);
    setErrorSala("");
  };

  // const handleOnclickTurnosQuirofanos = () => {
  //   setmodalOnTurnosQuirofano(true);
  // };

  const handleOnclickEmpresasXUsuario = () => {
    setmodalOnEmpresasXUsuario(true);
  };

  const handleClickSelecccionPaciente = () => {
    setmodalOnSeleccionPaciente(true);
  };

  const handleClickQuirofanos = () => {
    setmodalOnQuirifanoN(true);
  };
  const handleCancelarClick = () => {
    setmodalOnProgramacionDeCirugia(false);
  };

  const handleOnsumitGuardarDataPaciente = (e) => {
    e.preventDefault();
    
    //let inicioF = e.target.fechaInicial.value.split("-");
    //let finalF = e.target.fechaFinal.value.split("-");
    
   // en este metodo vamos a validar los quirofanos que esten disponibles, sino lo esta aparece un modal explicando
    const validarQuirofano={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProEsta:'3',
      ProFec:e.target.fechaInicial.value,
      ProFecF:e.target.fechaFinal.value,
      ProCons: e.target.numeroCirugia.value,
      ProSedQr:usuarioInfo.Sede
    }
    let quirofanoError=''
    postVerificarQuirofanoOcupado(validarQuirofano).then((res)=>{
     
       let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`).getTime();
       inputFechaInicial = inputFechaInicial + 60000
       let inputFechaFinal = new Date(`${e.target.fechaFinal.value} ${e.target.horaFinal.value}:00`).getTime();
       inputFechaFinal = inputFechaFinal - 60000

       let quirofanoOcupados= res.data.find((validar)=>{
        let quirofanoFechaInicial = new Date(`${validar.ProFec.split(' ')[0]} ${validar.ProHorI}`).getTime();
        let quirofanoFechaFinal = new Date(`${validar.ProFecF.split(' ')[0]} ${validar.ProHorF}`).getTime();
        return Math.min(inputFechaInicial, inputFechaFinal) <= Math.max(quirofanoFechaInicial, quirofanoFechaFinal) && Math.max(inputFechaInicial, inputFechaFinal) >= Math.min(quirofanoFechaInicial, quirofanoFechaFinal)           
          
       })
         
       if(quirofanoOcupados) {
        seterrorDataQuirofanosOcupados(quirofanoOcupados)
        setmodalOnQuirofanosOcupados(true)
        quirofanoError = 'Error'
       }else{
        quirofanoError = ''
        // metodo que me sirve para saber los horarios de los quirofanos
        let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`)
        setdiaQuirofano(inputFechaInicial.getDay())
        
        let quirofanoErrorHorario=''
        const horario={
          ConsCod:passDataQuirofanoN.codigoQuirofano,
          ConsDia:inputFechaInicial.getDay()+1
        }
        
        postHorarioQuirofanos(horario).then((res)=>{
          //console.log(res.data,'horarios')
          setdataHorariosQuirofanos(res.data[0])
          let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`).getTime();
          inputFechaInicial = inputFechaInicial + 60000
          let inputFechaFinal = new Date(`${e.target.fechaFinal.value} ${e.target.horaFinal.value}:00`).getTime();
          inputFechaFinal = inputFechaFinal - 60000

          let quirofanoOcupados= false
          // res.data.find((validar)=>{
            
          //   let quirofanoFechaInicial = new Date(`${e.target.fechaInicial.value} ${validar.CoHEntQui}`).getTime();
          //   let quirofanoFechaFinal = new Date(`${e.target.fechaFinal.value} ${validar.CoHSalQui}`).getTime();
            
          //   return   quirofanoFechaInicial <= inputFechaInicial  && inputFechaFinal >= quirofanoFechaFinal  ||      quirofanoFechaInicial >= inputFechaInicial  && inputFechaFinal <= quirofanoFechaFinal 
          // })
          if(quirofanoOcupados) {
            
            setmodalOnHorarioQuirofanos(true)
            
            quirofanoErrorHorario = 'Error'
          }else{
            
            quirofanoErrorHorario = ''
            //son varios metodos anidados que me crean a un paciente con un id_cirugia nuevo, es complicado el proceso
            if (
              errorSala == "" &&
              errorContrato == "" &&
              errorHoraInicial == "" &&
              errorHoraFinal == "" &&
              errorFechaInicial == "" &&
              errorFechaFinal == "" &&
              errorNumeroDocumento == "" &&
              errorTipodeDocumento == "" 
            ) {
              setloading(false)
              const ultimoIDCirugia = {
                varEMPCOD: "1",
                varDOCCOD: "PCI",
                varEMPCOD: "1",
                varDOCCOD: "PCI",
                varDocNumEs: "A",
              };
              postObtenerElUltimoIDCirugia(ultimoIDCirugia).then((res) => {
                //console.log(res.data[0].DocNumAc,'DocNumAc')
                let ultimoID = parseInt(res.data[0].DocNumAc);
                
              let fecha = new Date();
              let mes = `${fecha.getMonth() + 1}`    
              if(mes.length === 1){
                mes = "0" + mes
              }
              let dia = `${fecha.getDate()}`
              if(dia.length === 1){
                dia = "0" + dia
              }
        
            
              
          //     const body = {
          //       Id_cirugia: ultimoID,
          //       cedula_paciente: passDataUser.numeroUser,
          //       nombre_cirujano: passDataUser.nombreUser,
          //       nombre_paciente: passDataUser.nombreUser,
          //       estado_paciente: 'reservado',
          //       fecha_cambio_estado: `${fecha.getFullYear()}-${mes}-${dia}`,
          //       hora_cambio_estado: `${fecha.getHours()}:${fecha.getMinutes()}`,
          //     };
          // postSelectCambiarEstadoPaciente(body)
          
        
                const actualizarn = {
                  DocNumEs: "A",
                  DOCCOD: "PCI",
                  EMPCOD: usuarioInfo.Empresa ,
                  DocNumBq: "N",
                  DocNumIn: "1",
                  DocNumFi: "99999999999999",
                  DocCon: "1",
                  DocNumAc: String(ultimoID),
                  MCDpto: usuarioInfo.Sede,
                };
                //console.log(actualizarn, "actializaaaaaaa anetes");
                postActualizarIDCirugia(actualizarn).then((res) => {    
                  //calcular hora y minutos
                  let horaInicialI = e.target.horaInicial.value;
                  let horaFinalF = e.target.horaFinal.value;
                  let [horaInicialHora, horaInicialMinuto] = horaInicialI.split(":").map(Number);
                  let [horaFinalHora, horaFinalMinuto] = horaFinalF.split(":").map(Number);
                  let minutosInicial = horaInicialHora * 60 + horaInicialMinuto;
                  let minutosFinal = horaFinalHora * 60 + horaFinalMinuto;
                  let diferenciaMinutos = minutosFinal - minutosInicial;
                  let horas = Math.floor(diferenciaMinutos / 60);
                  let minutos = diferenciaMinutos % 60;

                  
        
                  //insertar
                  const insertarn = {
                    ProCirCod: String(ultimoID),
                    ProMCDpto: usuarioInfo.Sede,
                    ProEmpCod: usuarioInfo.Empresa,
                    ProHorI: e.target.horaInicial.value + ":00",
                    ProHorF: e.target.horaFinal.value + ":00",
                    ProFSep: e.target.fechaInicial.value, //                     `${inicioF[0]}-${inicioF[2]}-${inicioF[1]}` + " 00:00:00.000",
                    ProFec:e.target.fechaInicial.value,   //`${inicioF[0]}-${inicioF[2]}-${inicioF[1]}` + " 00:00:00.000",
                    ProFecF: e.target.fechaFinal.value, //`${finalF[0]}-${finalF[2]}-${finalF[1]}` + " 00:00:00.000",
                    ProCons: e.target.numeroCirugia.value,
                    ProSedQr: usuarioInfo.Sede,
                    ProEsta: "1",
                    ProIndUso: "N",
                    ProIndOpu: e.target.indOp.value,
                    MPCedu: passDataUser.numeroUser,
                    MPTDoc: passDataUser.tipoDocumentoUser,
                    ProEPS: passDataContrato.descripcionNit,
                    ProDurHr:`${horas}`,
                    ProDurMn:`${minutos}`
                  };
                  console.log(insertarn, "insertaer bodyyy");
        
                  postInsertIDCirugia(insertarn).then((res) => {
                    
                    passDataActualizaTablaPacientes(insertarn);
                    setmodalOnProgramacionDeCirugia(false);

                    //insertar en turqui
                  const insertQuirofanos={
                    "EMPCOD":usuarioInfo.Empresa,
                    "MCDpto":usuarioInfo.Sede,
                    "DOCCOD":"RTQ",
                    "ProCirCod":String(ultimoID),
                    "TuQMedRes": "",
                    "TuQUsrRes":  usuarioInfo.UsuarioEncriptado,
                    "TuQNroAut": "                    ",
                    "TuQEstTur": "C",
                    "TuQObs": "",
                    "TuQTpAnst": " ",
                    "TuInsCod": "0",
                    "TuInsXML": "",
                    "TuQFchSal": e.target.fechaFinal.value,
                    "TuQFchIng": e.target.fechaInicial.value,
                    "TuQHorIng":e.target.horaInicial.value + ":00",
                    "TuQHorSal": e.target.horaFinal.value + ":00",
                    "TuQCodCto": passDataContrato.descripcionNit,
                    "ConsCod": e.target.numeroCirugia.value,
                }
                  console.log(insertQuirofanos,'quirofanos antes')
                  postInsertQuirofanos(insertQuirofanos).then((res)=>{
                    console.log(res.data,'quirofanos')
                  }).catch((error) => {
                    console.error('Error al autenticar al usuario:', error);
                    //seterrorEndpoint(true);
                    
                  });
                  ///fin turqui///

                  });
                });
              });
            } else {
              //console.log("con error");
            }
          }
        })
       }

      
     
    })

    
  };

  
 

  useEffect(() => {
    setErrorSala("Seleccionar una Sala");
    setErrorContrato("Debe Seleccionar Contrato");
    setErrorHoraInicial("Seleccionar una Hora Inicial");
    setErrorHoraFinal("Seleccionar una Hora Final");
    seterrorNumeroDocumento("Seleccionar un número de documento");
    seterrorTipodeDocumento("Seleccionar tipo de documento");
    
    let fecha = new Date()
    let year = fecha.getFullYear()
    let mes = `${fecha.getMonth() + 1}`
    let dia = `${fecha.getDate()}`    
    if(mes.length == '1'){
        mes = `0${fecha.getMonth() + 1}`
    }else{
        mes = `${fecha.getMonth() + 1}`
    }
    
    if(dia.length == '1'){
        dia = `0${fecha.getDate()}`
    }else{
        dia = `${fecha.getDate()}`
    }
    let fechaCompleta = `${year}-${mes}-${dia}`
    setFechaInicio(fechaCompleta)
    setFechaFinal(fechaCompleta)
    setFechaActual(fechaCompleta)

    getTipoDeDocumento().then((res) => {
      //console.log(res.data,'tipooo')
      settipoDocumento(res.data);
    });

    // Crear un objeto Date con la fecha y hora actual en la zona horaria UTC
const now = new Date();


  }, []);

  const handleOnchangeHoraInicial = (e) => {
    setHoraInicial(e.target.value);
    let horasMinutos = e.target.value
    //console.log(e.target.value,'horainicial')
    //console.log(horaFinal,'horafinal')
    //validar hora actual
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
    // console.log((validarFechaActual() === fechaInicio),'inputt')
    // console.log(fechaActual,'fechaActual')
    // console.log(fechaInicio,'fechaInicio')
    
    //condicional para validar
    //if(e.target.value)
      //if (horaFinal !== "") {
        let timeInicial = new Date(`${fechaActual} ${e.target.value}`);
        let timeFinal = new Date(`${fechaActual} ${horaFinal}`);
        let restaInicialFinal = timeFinal - timeInicial;
        
        if(!horasMinutos){
          setErrorHoraInicial("Seleccionar hora inicial")
          setErrorHoraFinal("")
        }else if(!horaFinal){
          setErrorHoraInicial("")
          setErrorHoraFinal("Seleccionar hora final")
        }
        else if (restaInicialFinal < 0) {
          setErrorHoraInicial("Hora Inicial no puede ser mayor a la Hora Final");
          setErrorHoraFinal("");
        } else if (restaInicialFinal == 0) {
          setErrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final");
          setErrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial");
        } else if((horasMinutos < currentLocalTime ) && (fechaActual === fechaInicio)){
          setErrorHoraInicial("Hora Inicial no puede ser menor a la Hora Actual");
          setErrorHoraFinal("");
        }else if((horaFinal < currentLocalTime) && (fechaActual === fechaFinal)){
          setErrorHoraInicial("");
          setErrorHoraFinal("Hora final no puede ser menor a la Hora Actual");
        }     
        else {
          setErrorHoraInicial("");
          setErrorHoraFinal("");
        } 
        // else if (restaInicialFinal > 0) {
        //   setErrorHoraInicial("");
        //   setErrorHoraFinal("");
        // }
  
       
    
  };

  const handleOnchangeHoraFinal = (e) => {
    setHoraFinal(e.target.value);
    let horasMinutos = e.target.value
    //validar hora actual
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
    
      //if (horaInicial != "") {
        let timeInicial = new Date(`${fechaActual} ${horaInicial}`);
        let timeFinal = new Date(`${fechaActual} ${e.target.value}`);
        let restaInicialFinal = timeFinal - timeInicial;
        if(!horasMinutos){
          setErrorHoraFinal("Seleccionar hora final")
          setErrorHoraInicial("")
        }else if(!horaInicial){
          setErrorHoraFinal("")
          setErrorHoraInicial("Seleccionar hora inicial")
        }
         else if (restaInicialFinal < 0) {
          setErrorHoraInicial("");
          setErrorHoraFinal("Hora Final no puede ser menor a la Hora Inicial");
        } else if (restaInicialFinal == 0) {
          setErrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final");
          setErrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial");
        } else if((horasMinutos < currentLocalTime) && (fechaActual === fechaFinal) ){
          setErrorHoraInicial("");
          setErrorHoraFinal("Hora Final no puede ser menor a la Hora Actual");
        }else if((horaInicial < currentLocalTime) && (fechaActual === fechaInicio)){
          setErrorHoraInicial("Hora Inicial no puede ser menor a la Hora Actual");
          setErrorHoraFinal("");
        }
        else  {
          setErrorHoraInicial("");
          setErrorHoraFinal("");
        }
        // else if (restaInicialFinal > 0) {
        //   setErrorHoraInicial("");
        //   setErrorHoraFinal("");
        // }
      // } else{
      //   setErrorHoraInicial("Seleccionar hora inicial")
      // }
    
    
    
  };

  const handleOnchangeFechaInicial = (e) => {
    setFechaInicio(e.target.value);
    let dateInicial = new Date(e.target.value);
    let dateFinal = new Date(fechaFinal);
    let restaInicialFinal = dateFinal - dateInicial;
    let dateActual = new Date(fechaActual);
    let restActualInicio = dateInicial - dateActual;

    
    if (restActualInicio < 0) {
      seterrorFechaInicial(
        "Fecha Inicial no puede ser menor a la fecha actual"
      );
      setErrorFechaFinal("");
    } else if (restaInicialFinal < 0) {
      seterrorFechaInicial("Fecha Inicial no puede ser mayor a la Fecha Final");
      setErrorFechaFinal("");
    } else if (restaInicialFinal != 0) {
      setErrorFechaFinal(
        "La duración de la cirugia supera las 24 horas, verifique"
      );
      seterrorFechaInicial(
        "La duración de la cirugia supera las 24 horas, verifique"
      );
    } else if (restaInicialFinal >= 0) {
      seterrorFechaInicial("");
      setErrorFechaFinal("");
    }

    //validar hora
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

    if(!horaFinal){
      setErrorHoraFinal("Seleccionar hora final")
      setErrorHoraInicial("")
    }else if(!horaInicial){
      setErrorHoraInicial("Seleccionar hora inicial")
      setErrorHoraFinal("")
    }
    else if((fechaActual === fechaFinal) && (horaFinal < currentLocalTime)){
      setErrorHoraInicial("");
      setErrorHoraFinal("Hora Final no puede ser menor a la Hora Actual");
    }else if((horaInicial < currentLocalTime) && (fechaActual === e.target.value)){
      setErrorHoraInicial("Hora Inicial no puede ser menor a la Hora Actual");
      setErrorHoraFinal("");
    }
    else if(horaInicial === horaFinal){
      setErrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final")
      setErrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial")
    }else if(horaInicial > horaFinal){
      setErrorHoraInicial("Hora Inicial no puede ser mayor a la Hora Final")
      setErrorHoraFinal("")
    }else if(verificarHoras(horaInicial,horaFinal)){
      setErrorHoraInicial("Hora Inicial no puede ser mayor a la Hora Final")
      setErrorHoraFinal("")
    }   
    else{
      setErrorHoraInicial("");
      setErrorHoraFinal("");
    }
  };

  const handleOnchangeFechaFinal = (e) => {
    setFechaFinal(e.target.value);
    let dateInicial = new Date(fechaInicio);
    let dateFinal = new Date(e.target.value);
    let restaInicialFinal = dateFinal - dateInicial;
    let dateActual = new Date(fechaActual);
    let restActualInicio = dateFinal - dateActual;

    if (restActualInicio < 0) {
      setErrorFechaFinal("Fecha Final no puede ser menor a la fecha actual");
      seterrorFechaInicial("");
    } else if (restaInicialFinal < 0) {
      setErrorFechaFinal("Fecha Final no puede ser menor a la fecha inicial");
      seterrorFechaInicial("");
    } else if (restaInicialFinal != 0) {
      setErrorFechaFinal(
        "La duración de la cirugia supera las 24 horas, verifique"
      );
      seterrorFechaInicial(
        "La duración de la cirugia supera las 24 horas, verifique"
      );
    } else if (restaInicialFinal >= 0) {
      seterrorFechaInicial("");
      setErrorFechaFinal("");
    }

    //validar hora
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
    if(!horaFinal){
      setErrorHoraFinal("Seleccionar hora final")
      setErrorHoraInicial("")
    }else if(!horaInicial){
      setErrorHoraInicial("Seleccionar hora inicial")
      setErrorHoraFinal("")
    }
    else if((fechaActual === e.target.value) && (horaFinal < currentLocalTime)){
      setErrorHoraInicial("");
      setErrorHoraFinal("Hora Final no puede ser menor a la Hora Actual");
    }else if((horaInicial < currentLocalTime) && (fechaActual === fechaInicio)){
      setErrorHoraInicial("Hora Inicial no puede ser menor a la Hora Actual");
      setErrorHoraFinal("");
    }
    else if(horaInicial === horaFinal){
      setErrorHoraInicial("Hora Inicial no puede ser igual a la Hora Final")
      setErrorHoraFinal("Hora Final no puede ser igual a la Hora Inicial")
    }else if(verificarHoras(horaInicial,horaFinal)){
      setErrorHoraInicial("Hora Inicial no puede ser mayor a la Hora Final")
      setErrorHoraFinal("")
    } 
    else{
      setErrorHoraInicial("");
      setErrorHoraFinal("");
    }
  };

  function verificarHoras(horaInici, horaFina) {
    // Crear objetos Date a partir de las horas proporcionadas
    const [horaInicio, minutoInicio] = horaInici.split(':').map(Number);
    const [horaFin, minutoFin] = horaFina.split(':').map(Number);

    const inicio = new Date();
    inicio.setHours(horaInicio, minutoInicio, 0, 0);

    const fin = new Date();
    fin.setHours(horaFin, minutoFin, 0, 0);

    // Verificar si la hora inicial es mayor que la hora final
    if (inicio > fin) {
        return true;
    } else {
        return false;
    }
}

  // const validarFechaActual=()=>{
  //   // Crear un objeto Date con la fecha y hora actual en la zona horaria UTC
  //   const now = new Date();

  //   // Configurar las opciones para la fecha en la zona horaria de Colombia
  //   const options = {
  //       timeZone: 'America/Bogota',
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit'
  //   };

  //   // Formatear la fecha según las opciones especificadas
  //   const colombiaDate = new Intl.DateTimeFormat('es-CO', options).format(now);

  //   return colombiaDate

  //   // console.log(colombiaDate);
  // }

  //Quirofano Sala
  //const handleOnchangeSala = (e) => {};

  // const handleOnchangeUser = (e) => {
  //   //console.log(e.target.value, "inputt informacion");
  //   if (e.target.value) {
  //     seterrorNumeroDocumento("");
  //   } else {
  //     seterrorNumeroDocumento("Seleccionar un número de documento");
  //   }
  // };

  // const handleOnchangeTipoDocumento = (e) => {
  //   //seterrorTipodeDocumento("")
  //   if (e.target.value !== "   " && e.target.value !== "") {
  //     seterrorTipodeDocumento("");
  //   } else {
  //     seterrorTipodeDocumento("Seleccionar tipo de documento");
  //   }
  // };

  return (
    <>      
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Programación Sala de Cirugía
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            {loading? 
            <div className="flex-auto overflow-y-auto relative p-4">
              {/* <form onSubmit={handleOnsubmitBuscarPorCedulaYTipo}> */}
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/3  px-2 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número del documento
                    </label>
                    <input
                      //ref={ref}
                      disabled={true}
                      autoComplete="off"
                      type="text"
                      name="numeroDelDocumento"
                      //onChange={handleOnchangeUser}
                      defaultValue={passDataUser.numeroUser}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorNumeroDocumento}
                    </label>
                  </div>
                  <div className="w-1/3  px-2 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium ">
                      Tipo de documento
                    </label>
                    <input
                      //ref={ref}
                      disabled={true}
                      autoComplete="off"
                      type="text"
                      name="tipoDocumento"
                      //onChange={handleOnchangeUser}
                      defaultValue={passDataUser.tipoDocumentoUser}
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                   
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorTipodeDocumento}
                    </label>
                  </div>
                 
                  
                  <div className="w-1/3  px-2 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium">
                      Buscar Paciente
                    </label>
                    <button
                      onClick={handleClickSelecccionPaciente}
                      type="button"
                      className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Seleccionar paciente
                    </button>
                  </div>
                </div>
                <div className="flex text-left w-2/4">
                  <div className="w-full  px-2 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">Nombre Paciente</label>
                    <input
                      defaultValue={passDataUser.nombreUser}
                      autoComplete="off"
                      type="text"
                      disabled={true}
                      name="codigoProcedimiento"
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              {/* </form> */}
              <form onSubmit={handleOnsumitGuardarDataPaciente}>
                <div className="flex-auto overflow-y-auto relative py-4">
                  <div className="flex flex-row   text-left">
                    <div className="w-1/3  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Número Sala
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={passDataQuirofanoN.codigoQuirofano}
                        name="numeroCirugia"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorSala}
                      </label>
                    </div>
                    <div className="w-1/3  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Nombre Sala
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        defaultValue={passDataQuirofanoN.descripcionQuirofano}
                        name="nombreCirugia"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/3  px-2 ">
                      <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                      <button
                        onClick={handleClickQuirofanos}
                        type="button"
                        className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                      >
                        Seleccionar sala
                      </button>
                    </div>
                  </div>

                  <div className="flex py-2 text-left">
                    <div className="w-1/2  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Contrato
                      </label>
                      <input
                        defaultValue={passDataContrato.descripcionNit}
                        onFocus={handleOnclickEmpresasXUsuario}
                        autoComplete="off"
                        type="text"
                        name="cantidadProcedimiento"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorContrato}
                      </label>
                    </div>
                    <div className="w-1/2  px-2 ">
                      <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                      <input
                        defaultValue={passDataContrato.nomUser}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        name="cantidadProcedimiento"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Fecha Inicial
                      </label>
                      <input
                        onChange={handleOnchangeFechaInicial}
                        autoComplete="off"
                        type="date"
                        name="fechaInicial"
                        value={fechaInicio}
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorFechaInicial}
                      </label>
                    </div>
                    <div className="w-2/3  px-2">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Hora Inicial
                      </label>
                      <input
                        onChange={handleOnchangeHoraInicial}
                        autoComplete="off"
                        name="horaInicial"
                        type="time"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorHoraInicial}
                      </label>
                    </div>
                    {/* <div className="w-2/3  px-4">
                      <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                      <button
                        type="button"
                        onClick={handleOnclickTurnosQuirofanos}
                        className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                      >
                        TurnosQ
                      </button>
                    </div> */}
                    <div className="w-1/3  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Fecha Final
                      </label>
                      <input
                        onChange={handleOnchangeFechaFinal}
                        value={fechaFinal}
                        autoComplete="off"
                        type="date"
                        name="fechaFinal"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorFechaFinal}
                      </label>
                    </div>
                    <div className="w-2/3  px-2">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Hora Final
                      </label>
                      <input
                        autoComplete="off"
                        name="horaFinal"
                        onChange={handleOnchangeHoraFinal}
                        type="time"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {errorHoraFinal}
                      </label>
                    </div>
                  </div>
                  <div className="w-1/3  px-4 py-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                      Indicador de Oportunidad Cirugía
                    </label>
                    <input
                      autoComplete="off"
                      defaultValue={"1"}
                      type="text"
                      name="indOp"
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>

                <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                  <button
                    type="button"
                    onClick={handleCancelarClick}
                    className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Guardar
                  </button>
                </div>
              </form>
            </div>
              :
              <div className="text-center py-40"><Loading/></div>
              }
          </div>
        </div>
      </div>
      {modalOnQuirifanoN ? (
        <ModalProgramacioDeunaCirugiaQuirofanoN
          setmodalOnQuirifanoN={setmodalOnQuirifanoN}
          passInfoDataQuirofano={passInfoDataQuirofano}
        />
      ) : null}

      {modalOnSeleccionPaciente ? (
        <ModalListaDeSeleccionPacientesXNombreN
          setmodalOnSeleccionPaciente={setmodalOnSeleccionPaciente}
          passDataInfoUser={passDataInfoUser}
        />
      ) : null}
      {modalOnEmpresasXUsuario ? (
        <ModalListaDeSeleccionEmpresasXUsuario
          setmodalOnEmpresasXUsuario={setmodalOnEmpresasXUsuario}
          passDataUser={passDataUser}
          passDataContratoUser={passDataContratoUser}
        />
      ) : null}
      {modalOnTurnosQuirofano ? (
        <ModalListaSeleccionTurnosQuirofano
          setmodalOnTurnosQuirofano={setmodalOnTurnosQuirofano}
          passDataQuirofanoN={passDataQuirofanoN}
        />
      ) : null}
      {
        modalOnQuirofanosOcupados? <ModalQuirofanoOcupado setmodalOnQuirofanosOcupados={setmodalOnQuirofanosOcupados} errorDataQuirofanosOcupados={errorDataQuirofanosOcupados}/>:null
      }
      {
        modalOnHorarioQuirofanos? <ModalHorariosQuirofanos setmodalOnHorarioQuirofanos={setmodalOnHorarioQuirofanos} dataHorariosQuirofanos={dataHorariosQuirofanos} diaQuirofano={diaQuirofano} passDataQuirofanoN={passDataQuirofanoN}/>:null
      }
    </>
  );
};

export default ModalProgramacionDeUnaCirugiaN;
